import {Component, OnInit} from '@angular/core';
import {ConsumableAdstxtRecord} from '../../domain/consumable-adstxt-record.model';
import {MomentDateUtils} from '../../utils/moment-date-utils';
import {Utils} from '../../utils/utils';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Principal} from '../../auth/principal.service';
import {UserUtils} from '../../domain/users/user-utils.model';

@Component({
  selector: 'cm-ads-txt',
  templateUrl: './ads-txt.component.html',
})
export class AdsTxtComponent implements OnInit {

  public lastUpdatedDate: any;
  private adstxtRecords: ConsumableAdstxtRecord[] = [];
  public isPublisher: boolean;

  constructor(private httpClient: HttpClient,
              private principal: Principal) {
    this.isPublisher = UserUtils.isPublisher(this.principal.getUser());
  }

  ngOnInit(): void {
    this.getAdsTxt().subscribe(next => {
      this.adstxtRecords = next;
      this.getLastUpdatedDate();
    });
  }

  getAdsTxt(): Observable<ConsumableAdstxtRecord[]> {
    if (this.isPublisher) {
      return this.httpClient.get<ConsumableAdstxtRecord[]>(`${environment.serviceUrl}/ad-stats/publisher-stats/consumable-adstxts`);
    } else {
      return this.httpClient.get<ConsumableAdstxtRecord[]>(`${environment.serviceUrl}/ad-stats/dp-stats/consumable-adstxts`);
    }
  }

  download() {
    this.txtExport(this.adstxtRecords);
  }

  getLastUpdatedDate() {
    this.lastUpdatedDate = MomentDateUtils.format(Math.max(...this.adstxtRecords.map(function (adstxts) {
      return adstxts.updatedOn;
    })));
  }

  txtExport(data) {
   Utils.exportAdsTxt(data, true);
  }
}
